export const createRepaymentSlice = (set) => ({
  loanId: null,
  loanScheduleId: null,
  repaymentTransactionId: null,
  paymentSuccessData: null,
  isRecallLoan: false,
  isForecloseLoan: false,

  setLoanId: (loanId) => set({ loanId }),
  setLoanScheduleId: (loanScheduleId) => set({ loanScheduleId }),
  setRepaymentTransactionId: (repaymentTransactionId) => set({ repaymentTransactionId }),
  setPaymentSuccessData: (paymentSuccessData) => set({ paymentSuccessData }),
  setLoanActionFlags: (isRecallLoan, isForecloseLoan) => set({ isRecallLoan, isForecloseLoan }),

  clearRepaymentData: () =>
    set({
      loanId: null,
      loanScheduleId: null,
      repaymentTransactionId: null,
      paymentSuccessData: null,
      isRecallLoan: false,
      isForecloseLoan: false,
    }),
});
